import { render, staticRenderFns } from "./ViewTransactionModal.vue?vue&type=template&id=06029e49"
import script from "./ViewTransactionModal.vue?vue&type=script&lang=js"
export * from "./ViewTransactionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports